module.exports = __webpack_public_path__ + "img/5.0db30891.jpg";